<input
  id="recipeSearch"
  #recipeSearch
  type="text"
  placeholder="Search recipes"
  (keydown.enter)="updateName(recipeSearch.value)"
/>
<button type="button" (click)="updateName(recipeSearch.value)">Search</button>
